<template>
    <div class="login-page">
        <RouterView></RouterView>
    </div>
</template>
<script lang="ts" setup>


</script>

<style lang="less" scoped>

.login-page {
    min-width: 100vw;
    min-height: 100vh;
    display: flex;
    text-align: center;
    padding-top: 40px;
    padding-bottom: 40px;
    background-color: #f5f5f5;

    
}

</style>